<template>
  <div class="sect-section">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 class="sect-title">Disciplinas</h1>
          <p class="lead text-center mb-5" style="color: #e9ecef;">
            Explore as disciplinas vampíricas e seus poderes até a 5ª edição para turbinar fichas de Vampiro A Máscara, com
            foco em V20 e V5, equilibrando clãs, crônicas e estilos de jogo.
          </p>
        </div>
      </div>

      <div class="row">
        <div
          class="col-md-4 mb-4"
          v-for="discipline in disciplines"
          :key="discipline.id"
        >
          <div class="card clan-card h-100" @click="selectDiscipline(discipline)">
            <div class="card-body">
              <div class="d-flex align-items-start">
                <div class="me-3">
                  <i class="bi bi-bookmark-star" style="font-size: 2rem; color: var(--vampire-gold);"></i>
                </div>
                <div class="flex-grow-1">
                  <h5 class="card-title mb-1">{{ discipline.name }}</h5>
                  <p class="card-text small mb-0">{{ discipline.shortDescription }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12 text-center">
          <button class="btn btn-vampire" @click="$emit('go-back')">
            <i class="bi bi-arrow-left me-2"></i>
            Voltar ao Início
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { disciplinesData } from '../data/disciplines.js'

export default {
  name: 'DisciplinesView',
  data() {
    return {
      disciplines: disciplinesData
    }
  },
  methods: {
    selectDiscipline(discipline) {
      this.$emit('show-discipline-modal', discipline)
    }
  }
}
</script>

<style scoped>

.clan-card {
  transition: all 0.3s ease;
  cursor: pointer;
}

.clan-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px var(--vampire-shadow);
}
</style>

